var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPostListItemFeedbackATu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.446.667L5.057 5.064c-.25.25-.39.588-.39.941v6.662c0 .736.597 1.333 1.334 1.333h5.995c.533 0 1.014-.317 1.225-.807l2.005-4.668c.072-.166.108-.346.108-.526V6.667c0-.737-.596-1.334-1.333-1.334H9.767l.625-2.864a1.336 1.336 0 00-.369-1.235L9.446.667zM.668 6v8h2.666V6H.668z",
    fill: "#212121"
  })));
}

export default __webpack_public_path__ + "e60bd1eda6d49c0092b30c2cad74e889.svg";
export { SvgPostListItemFeedbackATu as ReactComponent };